'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$0024100 from "./presto.-Two-Factor-Auth-View$$anon$100.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002498 from "./presto.-Two-Factor-Auth-View$$anon$98.js";
import * as $j_presto$002etypes$0024$002dGroup from "./presto.types$-Group.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dId$0024 from "./presto.types$-Group-Id$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$97() {
  this.bKq = null;
  this.bKi = null;
  this.bKj = false;
  this.bKr = null;
  this.bKs = false;
  this.bKv = null;
  this.bKo = null;
  this.bKp = false;
  this.bKk = null;
  this.bKl = false;
  this.bKm = null;
  this.bKn = false;
  this.bKt = false;
  this.bKu = false;
  this.bKq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bKv = "Group";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$97 as $c_Lpresto_TwoFactorAuthView$$anon$97 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$97.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$97;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$97() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$97 as $h_Lpresto_TwoFactorAuthView$$anon$97 };
$h_Lpresto_TwoFactorAuthView$$anon$97.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bKq;
});
$p.M = (function() {
  if ((!this.bKj)) {
    this.bKi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bKj = true;
  }
  return this.bKi;
});
$p.O = (function() {
  if ((!this.bKs)) {
    this.bKr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bKs = true;
  }
  return this.bKr;
});
$p.D = (function() {
  return this.bKv;
});
$p.t = (function() {
  if ((!this.bKp)) {
    this.bKo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bKp = true;
  }
  return this.bKo;
});
$p.N = (function() {
  if ((!this.bKl)) {
    this.bKk = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dId$0024.$m_Lpresto_types$GroupId$().pb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iQ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().mm(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002498.$c_Lpresto_TwoFactorAuthView$$anon$98())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bKl = true;
  }
  return this.bKk;
});
$p.Q = (function() {
  if ((!this.bKn)) {
    this.bKm = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$0024100.$c_Lpresto_TwoFactorAuthView$$anon$100());
    this.bKn = true;
  }
  return this.bKm;
});
$p.v = (function() {
  if ((!this.bKu)) {
    this.bKt = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), false);
    this.bKu = true;
  }
  return this.bKt;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee1060) => ((p) => \u03b4scrutinee1060.p8(p)))($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$97 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$97, "presto.TwoFactorAuthView$$anon$97", ({
  TK: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$97 as $d_Lpresto_TwoFactorAuthView$$anon$97 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$97.js.map
